import { render } from "./pendidikan-list-remote.vue?vue&type=template&id=6619479d"
import script from "./pendidikan-list-remote.vue?vue&type=script&lang=js"
export * from "./pendidikan-list-remote.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__